import React from "react";
import { Dropdown, IDropdownOption } from "@nuorder/components";
import { formatMessage } from "lib/globalize-util";
import { Field } from "react-querybuilder";

interface IProps {
    fieldData: Field;
    value?: any;
    handleOnChange(value: any): void;
    disabled?: boolean;
    className?: string;
    options: IDropdownOption[];
}

export const CustomFieldDropdown: React.FC<IProps> = ({
    options,
    fieldData,
    disabled,
    value,
    handleOnChange,
    className,
}) => {
    const maxDropdownOptionTextLength = React.useMemo(() => {
        const maxWidth = 250;
        const minWidth = 150;
        const checkBoxWidth = 20;
        let textLength =
            Math.max(...options.map(({ text }) => text.length)) * 10 + (fieldData?.multiple ? checkBoxWidth : 0);

        if (textLength > maxWidth) {
            textLength = maxWidth;
        } else if (textLength < minWidth) {
            textLength = minWidth;
        }
        return textLength;
    }, [options, fieldData]);
    const commonProps = {
        disabled: disabled,
        defaultValue: value,
        selectedKey: value,
        options,
        onChange: handleOnChange,
        className: className,
        placeHolder: fieldData?.placeholder ?? formatMessage("Select"),
        calloutProps: {
            styles: {
                root: {
                    width: maxDropdownOptionTextLength,
                },
            },
        },
    };

    if (fieldData?.multiple) {
        return (
            <Dropdown
                {...commonProps}
                multiSelect={true}
                isSearchable={true}
                selectAllText={formatMessage("Select All")}
                searchBoxPlaceholder={formatMessage("Search")}
                noResultsText={formatMessage("No results found")}
            />
        );
    }

    const handleRenderCustomOption = (
        option?: IDropdownOption,
        defaultRender?: (props?: IDropdownOption) => JSX.Element
    ) => {
        if (option?.data?.onRenderCustomOption) {
            return option?.data?.onRenderCustomOption(option);
        } else if (defaultRender) {
            return defaultRender(option);
        }
        return <></>;
    };
    return (
        <Dropdown
            {...commonProps}
            isSearchable={fieldData?.isSearchable}
            onRenderCustomOption={handleRenderCustomOption}
        />
    );
};
